module.exports = __webpack_public_path__ + "static/media/approve.248481c6.svg";